import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilters } from '../../../../../reducers/filtersSlice';

const DpeCheckbox = () => {
  const { collection: filtersCollection } = useSelector((state) => state.filters);
  const { dpe } = filtersCollection
  const dispatch = useDispatch();
  const dpeEnergyLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

  const handleChange = (e) => {
    const value = e.target.value;
    let newPayload = [...dpe]
    if (dpe.includes(value)) newPayload = dpe.filter(criteria => criteria !== value)
    else newPayload = [...dpe, value]

    dispatch(updateFilters(
      {...filtersCollection, dpe: newPayload}
    ))
  }

  return(
    <div>
      <div className='typo-bold-content vesta-margin-b-10'>Performance énergétique (DPE)</div>
      
      <div className='vesta-more-criteria-filter-container vesta-flex-row-start vesta-gap-15'>
        {dpeEnergyLetters.map((letter, index) => (
          <div key={`${letter}-${index}`} className='vesta-small-checkbox-card-container'>
            <input
              id={letter}
              type='checkbox'
              name='dpe_energy_letter'
              value={letter}
              checked={dpe.includes(letter)}
              onChange={handleChange}
              readOnly
            />

            <label htmlFor={letter} className='vesta-small-checkbox-card vesta-dpe-custom-checkbox vesta-margin-b-none'>
              <div className='vesta-checkbox-custom vesta-margin-r-10'>
                <i className='fa-solid fa-check vesta-no-margin-important'></i>
              </div>

              <div className={`vesta-dpe-label vesta-dpe-label-${letter}`}>
                {letter}
              </div>
            </label>
          </div>
        ))}
      </div>
    </div>
  )
};

export default DpeCheckbox;
